var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSweden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0332C24.8366 32.0332 32 24.8698 32 16.0332C32 7.19665 24.8366 0.0332031 16 0.0332031C7.16344 0.0332031 0 7.19665 0 16.0332C0 24.8698 7.16344 32.0332 16 32.0332Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5203 13.9463H31.8631C30.8404 6.09583 24.1277 0.0332031 15.9985 0.0332031C14.8039 0.0332031 13.6402 0.165266 12.5203 0.413516V13.9463H12.5203Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3469 13.9462V1.97868C3.95352 4.37581 0.808459 8.77275 0.134521 13.9463H8.3469V13.9462Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34683 18.1205H0.134521C0.808459 23.294 3.95352 27.691 8.3469 30.088L8.34683 18.1205Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5203 18.1205V31.6532C13.6402 31.9015 14.8039 32.0335 15.9985 32.0335C24.1277 32.0335 30.8404 25.9709 31.8631 18.1205H12.5203V18.1205Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0332031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweden);
export default __webpack_public_path__ + "static/media/sweden.c6b34a17.svg";
export { ForwardRef as ReactComponent };